import RouteNames from "./type";
import { connect } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import Loader from "../components/Loader";
import { isScopeLoading } from "../store/scope-loading/helpers";
import { UserScope } from "../store/user/types";
import { RootState } from "../store/root-reducer";
import Header from "../components/Header";
import useAuthentication from "../hooks/checkAuthentication";
import ZohoSalesIQ from "../components/ZohoSalesIQ";

interface LayoutProps {
  isLoading: boolean;
}

function Layout({ isLoading: scopeLoader }: LayoutProps) {
  const { isAuthenticated, isLoading } = useAuthentication();
  return (
    <Loader isLoading={isLoading || scopeLoader}>
      {isAuthenticated ? (
        <>
          <Header isAuthenticated={isAuthenticated} />
          <Outlet />
          <ZohoSalesIQ />
        </>
      ) : (
        <Navigate to={RouteNames.AUTH} />
      )}
    </Loader>
  );
}
const mapStateProps = (state: RootState) => ({
  isLoading: isScopeLoading(state.scopeLoading, UserScope),
});

export default connect(mapStateProps)(Layout);
